module.exports = __webpack_public_path__ + "assets/img/yukon-s.e541e6e8.png";